import { modalTypes } from './constants';

const isTransferMnemonicOpen = state => Boolean(state.modals.getIn([modalTypes.transferMnemonic, 'active']));
const getTransferMnemonicCallback = state => state.modals.getIn([modalTypes.transferMnemonic, 'callback']);
const isBackupMnemonicOpen = state => Boolean(state.modals.getIn([modalTypes.backupMnemonic, 'active']));
const gerBackupMnemonicSuccessCallback = state => state.modals.getIn([modalTypes.backupMnemonic, 'successCallback']);
const gerBackupMnemonicCancelCallback = state => state.modals.getIn([modalTypes.backupMnemonic, 'cancelCallback']);

const modalSelectors = {
  isTransferMnemonicOpen,
  getTransferMnemonicCallback,
  isBackupMnemonicOpen,
  gerBackupMnemonicSuccessCallback,
  gerBackupMnemonicCancelCallback,
};

export default modalSelectors;
